import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FieldFilter from './FieldFilter';
import { Button, Row, Input, InputGroup, InputGroupAddon, Col } from 'reactstrap';
import { Drawer, Button as Button2 } from 'antd';
import { FilterOutlined } from '@ant-design/icons';

class Filters extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            hideFilter:props.filterTemplateCompany === 'TEMPLATE_THREE' ? false: props.fetchAfterFilter ? false : true
        }
    }
    onChangeSearchBox = (e) => {
        const { onFilterChange, filter } = this.props;
        const value = e.target.value;
        this.setState({ value }, () => {
            const filterConfig = {
                filter: {
                    targetClassProperty: "*",
                    isSearch: true
                }
            }
            onFilterChange(filterConfig, [value]);
        })
    }
    onEnter = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            const { onFiltersApplied } = this.props;
            onFiltersApplied();
        }
    }

        getFilterConfigFromWorkflowItem(workflowItem) {
        let config = null;
        const {containerIndex} = this.props;
        if (workflowItem && workflowItem.layoutProperties && workflowItem.layoutProperties.readAllFilterConfig && workflowItem.layoutProperties.readAllFilterConfig[containerIndex] && workflowItem.layoutProperties.readAllFilterConfig[containerIndex].filterConfig) {
            config = workflowItem.layoutProperties.readAllFilterConfig[containerIndex].filterConfig;
        }
        else if (workflowItem && workflowItem.layoutProperties && workflowItem.layoutProperties.readAllFilterConfig && workflowItem.layoutProperties.readAllFilterConfig.filterConfig) {
            config = workflowItem.layoutProperties.readAllFilterConfig.filterConfig;
        }
        return config;
    }

    toggleFilterUIBOx = ()=> {
        this.setState({hideFilter:!this.state.hideFilter})
      }
    render() {
        const { onFiltersApplied, filterConfig,onClearAppliedFilters, filters,filterTemplate, allFilters,filterTemplateCompany,filterPlacement } = this.props;
    
        const filterConfigWI = this.getFilterConfigFromWorkflowItem(this.props.workflowItem);
        const allFiltersWI = (filterConfigWI && filterConfigWI.filterAll) ? true : false;

         if(!allFilters && !filters && allFiltersWI) {
            return (
                <div className='mb-3 mt-3'>
                    <InputGroup>
                        <Input
                            type="search"
                            name="search"
                            value={this.state.value}
                            onChange={this.onChangeSearchBox}
                            onKeyPress={this.onEnter}
                            id="allFiltersSearch"
                            placeholder="Search"
                        />
                        <InputGroupAddon addonType="prepend"><Button onClick={onFiltersApplied} size="sm">SEARCH</Button></InputGroupAddon>
                    </InputGroup>
                    
                </div>
            )
        }

 const hasMenuFilter = filterConfig && filterConfig.filters &&filterConfig.filters.some(function(filter) {
  return filter.isMenuFilter === true;
});
      if(hasMenuFilter) return null;
        const { hideFilter} = this.state;
        //if (!workflow) return null;
        //const { currentItem: { layoutProperties: { readAllFilterConfig }, typeModel: { fields } } } = workflow;
        //const filters = readAllFilterConfig ? readAllFilterConfig.filterConfig.filters : [];
        if (!filters || !filters.length) return null;
        if(allFilters) {
            return (
                <div className='mb-3 mt-3'>
                    <InputGroup>
                        <Input
                            type="search"
                            name="search"
                            value={this.state.value}
                            onChange={this.onChangeSearchBox}
                            onKeyPress={this.onEnter}
                            id="allFiltersSearch"
                            placeholder="Search"
                        />
                        <InputGroupAddon addonType="prepend"><Button onClick={onFiltersApplied} size="sm">SEARCH</Button></InputGroupAddon>
                    </InputGroup>
                    
                </div>
            )
        }

        if(this.props.filterFromTemplate){
            return(
                <div className='read-all-filter'>
                <div className='d-flex justify-content-end'>
		<Button2 className='button'  onClick={this.toggleFilterUIBOx.bind(this)} style={{marginRight:10}}>
		<FilterOutlined />
				Filters
				</Button2>
        </div>
        <Drawer title="Filters" onClose={this.toggleFilterUIBOx.bind(this)} open={!hideFilter} placement={filterPlacement} className='drawer_template2'>
          { !hideFilter &&     <div className='top_most_filters'>
             
                <Col className='filters-wrapper-template2 mb-1' >
                    {
                        filters.map((filter, index) => {
                            if(filter && filter.forSideFilter) return null;
                            if (typeof filter.isActive === 'boolean' && !filter.isActive) return null;
                            return <FieldFilter style={{marginTop:2}} template2={true} filterIndex={index} filter={filter} key={index} {...this.props} />
                        })
                    }
                </Col>
                <div className='filterButtons filterButtonsTemplate2'>
				
                    <Button onClick={onClearAppliedFilters}  color='primary' outline>Reset Filters</Button>
                    <Button onClick={onFiltersApplied}  color='primary'>Apply Filters</Button>
                            </div>
                </div>
           }
           </Drawer>
            </div>
            )
        }
        if(filterTemplate === 'Template3'){
            return (
                 <div className='top_most_filters_template3'>
                    <div className='mb-1'> </div>
                    <Row className='filters-wrapper_template3 mb-1'>
                        <Col>
                        {
                            filters.map((filter, index) => {
                                if(filter && filter.forSideFilter) return null;
                                if (typeof filter.isActive === 'boolean' && !filter.isActive) return null;
                                return <FieldFilter onFiltersApplied={onFiltersApplied} onClearAppliedFilters={onClearAppliedFilters} filterTemplate={filterTemplate} filterIndex={index} filter={filter} key={index} {...this.props} />
                            })
                        }
                        </Col>
                        <Col sm='2' lg='2' className='search_filter_top'>
                        <Button onClick={onFiltersApplied} size='sm' color='primary'>Search</Button>
                        </Col>
                    </Row>

                    </div>
            )
               
        }
        if(filterTemplateCompany === 'TEMPLATE_TWO'){
            return(
                <div className='read-all-filter' style={{marginTop:-20, marginRight: 40}}>
                <div className='d-flex justify-content-end'>
        <Button className="show-hide-button show-hide-button-template2" target='_blank' onClick={this.toggleFilterUIBOx.bind(this)}  size="sm">
            {hideFilter ?   <i className="fa fa-filter mr-1" aria-hidden="true"></i>:   <i className="fa fa-filter mr-1" aria-hidden="true"></i>}
        </Button>
        </div>
        <Drawer title="Filters" onClose={this.toggleFilterUIBOx.bind(this)} open={!hideFilter} placement={filterPlacement} className='drawer_template2'>
          { !hideFilter &&     <div className='top_most_filters'>
             
                <Col className='filters-wrapper-template2 mb-1' >
                    {
                        filters.map((filter, index) => {
                            if(filter && filter.forSideFilter) return null;
                            if (typeof filter.isActive === 'boolean' && !filter.isActive) return null;
                            return <FieldFilter style={{marginTop:2}} template2={true} filterIndex={index} filter={filter} key={index} {...this.props} />
                        })
                    }
                </Col>
                <div className='filterButtons filterButtonsTemplate2'>
				
                    <Button onClick={onClearAppliedFilters}  color='primary' outline>Reset Filters</Button>
                    <Button onClick={onFiltersApplied}  color='primary'>Apply Filters</Button>
                            </div>
                </div>
           }
           </Drawer>
            </div>
            )
        }
        return (
            <div className='read-all-filter' style={{marginTop:-20, marginRight: 40}}>
                <div className='d-flex justify-content-end'>
        <Button className="show-hide-button" target='_blank' onClick={this.toggleFilterUIBOx.bind(this)} color="link" size="sm">
            {hideFilter ? "Show Filter": "Hide Filter"}
        </Button>
        </div>
          { !hideFilter &&     <div className='top_most_filters'>
                <div className='mb-1'> </div>
                <Row className='filters-wrapper mb-1'>
                    {
                        filters.map((filter, index) => {
                            if(filter && filter.forSideFilter) return null;
                            if (typeof filter.isActive === 'boolean' && !filter.isActive) return null;
                            return <FieldFilter filterIndex={index} filter={filter} key={index} {...this.props} />
                        })
                    }
                </Row>
                <div className='d-flex justify-content-end filterButtons'>
					<Button onClick={onFiltersApplied} size='sm' color='primary'>Apply Filters</Button>
                    <Button onClick={onClearAppliedFilters} size='sm' color='link'><i className="fa fa-undo mr-1" aria-hidden="true"></i>Clear</Button>
                </div>
                </div>
           }
            </div>
        );
    }
}

Filters.propTypes = {
    workflow: PropTypes.object
};

export default Filters;